import { useEffect, useRef, useState } from 'react';
import Button from '../../../../../components/inc/Button'; 
import Popup from '../../../../../components/Popup/Popup';
import axios from 'axios';
import Helper from '../../../../../inc/Helper';
import Settings from '../../../../../inc/Settings';
import { getPopupMessageBasedOnStatus } from '../../../../../inc/Validation';
import Dropdown from '../../../../../components/Forms/Dropdown';
import NewOverlayLoader from '../../../../../components/PurchaseRequisition/common/NewOverlayLoader';
import Api from '../../../../../inc/Api';

let currentSearchTerm = '';
const AdvancedSettings = (props) => {
  const [actionDetails, setActionDetails] = useState({});
  const [apiLoading, setApiLoading] = useState(false);

  const allData = useRef([]);

  const query = new URLSearchParams(window.location.search);
  const workflowId = query.get('wid');
  const workflowBodyId = query.get('to_id');

  const getNodeId = () => `${+new Date()}`;

  useEffect(() => {
    if(props?.onClickNode) { getNodeActionData() };
  }, []);

  const modalClose = (resetNodeId=true) => { 
    props.hideActionModal(false);
    if(resetNodeId){ props.setOnClickNode() };
  };

  const mapApiItemToOption = (item) => {
    return {
      id: item.action_id,
      text: item.label
    };
  };

  const getNodeActionData = () => {
    setApiLoading(true);
    let api = Api;
    api.setUserToken()
    api.axios().get(Settings.baseUrl + `action/nodes/get?body_id=${workflowBodyId}&node_id=${props.onClickNode}`).then((res) => {
      if (res.data.success) {
        setActionDetails(res?.data?.data); 
        setApiLoading(false);
      }
    }).catch((err) => {
      getPopupMessageBasedOnStatus(err);
      setApiLoading(false);
    })
  };

  const checkInstance = async () => {
    try {
      let api = Api;
      api.setUserToken()
      const res = await api.axios().get(`${Settings.baseUrl}instance/check-by-body-id?body_id=${workflowBodyId}`);
      return res?.data?.instance_exist;
    } catch (err) {
      return false;
    }
  };

  const onCreateActionDetails = () => {
    const nodeID = getNodeId();
    const formData = {
      node_id: nodeID,
      workflow_id: +workflowId,
      body_id: workflowBodyId,
      parent_node_id: props.currentNode !== "1" ? +props.currentNode : null,
      parent_condition: props.currentHandleId != null ? props.currentHandleId === "a" : null,
      action_id: actionDetails.action_id
    }

    setApiLoading(true);
    let api = Api;
    api.setUserToken();
    api.axios().post(Settings.baseUrl + 'action/nodes/create', formData).then((res) => {
      if (res.data.success) {
        Helper.alert(res.data.message);
        setApiLoading(false); 
        props.hideActionModal(false)
        props.mainModal(false);
        props.addNode(props.currentNode, props.actionValue, props.currentHandleId, nodeID, ''); 
        setTimeout(() => { props.save() }, 100);
      }
    }).catch((error) => {
        getPopupMessageBasedOnStatus(error);
        setApiLoading(false);
      }
    )
  };

  const onUpdateActionDetails = () => {
    const formData = {
      node_id: props.onClickNode,
      workflow_id: +workflowId,
      body_id: workflowBodyId,
      action_id: actionDetails.action_id
    }

    setApiLoading(true);
    let api = Api;
    api.setUserToken()
    api.axios().post(Settings.baseUrl + 'action/nodes/update', formData).then((res) => {
      if (res.data.success) {
        Helper.alert(res.data.message);
        setApiLoading(false);
        modalClose();
        props.mainModal(false);
      }
    }).catch((error) => {
        getPopupMessageBasedOnStatus(error);
        setApiLoading(false);
      }
    )
  };

  const saveDataHandler = async () => {
    if (!actionDetails?.action_id) {
      Helper.alert('Action field is required', 'error');
      return;
    };

    if(!props.onClickNode) {
      onCreateActionDetails();
    } else {
      const value = await checkInstance();
      if (value) {
        Helper.alert("This workflow have instance, so you can't edit", 'error');
        return;
      };

      onUpdateActionDetails();
    };
  };

  const nodeDeleteHandler = async () => {
    const value = await checkInstance();
    if (value) {
      Helper.alert("This workflow have instance, so you can't delete", 'error');
    } else {
      setApiLoading(true);
      const formData = { "node_id": props.onClickNode };
      let api = Api;
      api.setUserToken();
      api.axios().post(Settings.baseUrl + 'workflow-node/delete', formData).then((res) => {
        if (res.data.success) {
          props.setDelete(true);
          modalClose();
          setApiLoading(false);
        }
      }).catch((error) => {
        getPopupMessageBasedOnStatus(error);
        setApiLoading(false);
      })
    };
  };
 
  return (
    <Popup onClose={modalClose} autoOpen={true}>
      {apiLoading ? <NewOverlayLoader isPopupInTab={true} /> : null }

      <h3>Action</h3>
      <p>You need an action for a conditional decision</p>

      <div className="row label-form">
        <div className="col-lg-6 col-md-3">
          <Dropdown
            id="action_id"
            label={Helper.getLabel(props?.language, 'action_id', 'Action')}
            apiUrl={`${Settings.baseUrl}action`}
            apiTokenRequired={false}
            pagination={true}
            reRenderRequired={true}
            required={true}
            options={props.onClickNode ? [{label: actionDetails?.action_name, value: actionDetails?.action_id}] : []}
            value={actionDetails?.action_id}
            currentSearchTerm={currentSearchTerm}
            allDataRef={allData}
            mapFunction={mapApiItemToOption}
            onChange={(e) => setActionDetails((prevState) => {
              return {
                ...prevState,
                action_id: e.target.value
              }
            })}
          />
        </div>
      </div>

      <div className="d-flex justify-content-end mt-4">
        <Button className="mx-1" title="Cancel" onClick={modalClose} />
        {props.onClickNode && (
          <Button
            className="mx-1 red-btn-style"
            title="Delete"
            isDisable={apiLoading}
            onClick={nodeDeleteHandler}
          />
        )}
        <Button
          isDisable={apiLoading}
          className="mx-1"
          title="Save"
          icon="/images/icons/save-white.svg"
          isActive
          onClick={saveDataHandler}
        />
      </div>
    </Popup>
  );
};

export default AdvancedSettings;